// extracted by mini-css-extract-plugin
export default {"dialogContent":"style--dialogContent--89ceed","tabContent":"style--tabContent--51e85a"};